const groupedIntegerFormatter = new Intl.NumberFormat("en-US", {maximumFractionDigits: 0,});

const groupedFixedUsdFormatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

export const formatGroupedPrice = (value: number): string => {
    if (!Number.isFinite(value)) return "0";

    if (Number.isInteger(value)) {
        return groupedIntegerFormatter.format(value);
    }

    return value.toLocaleString("en-US");
};

export const formatUsdAmount = (value: number): string => {
    if (!Number.isFinite(value)) return groupedFixedUsdFormatter.format(0);
    return groupedFixedUsdFormatter.format(value);
};

export const formatMicrousdToUsdAmount = (
    value?: number | string | null,
): string => {
    return formatUsdAmount(Number(value || 0) / 1_000_000);
};
